module.exports = __webpack_public_path__ + "static/media/event-screenshot-beliebers.784df5fd.png";